import React from 'react';
import { FacebookIcon } from 'lucide-react';
import { Logo } from './Logo';
import { footerInfo } from '../data/homepage';
export function Footer() {
  return <footer className="w-full bg-ville-coral text-white" data-id="element-1337" data-mp="3ghc0bvkn0rl2">
      <div className="mx-auto max-w-[1500px] px-5 py-10 lg:px-10" data-id="element-1338" data-mp="32ovzn1f7l5nb">
        <div className="flex flex-wrap items-center gap-x-8 gap-y-5" data-id="element-1339" data-mp="36p6aardy4k8i">
          <Logo variant="light" data-id="element-1340" data-mp="36n3d9nedlqua" />

          <ul className="flex flex-wrap items-center gap-x-3 gap-y-2 text-[15px]" data-id="element-1341" data-mp="3ueim7z0nr6ei">
            {footerInfo.links.slice(0, 3).map((label, index) => <li key={label} className="flex items-center gap-3" data-id="element-1342" data-mp="37xv6falryhh" data-mpi={index}>
                {index > 0 && <span className="text-white/50" aria-hidden="true" data-id="element-1343" data-mp="3lggcmv2uz5fm">
                    |
                  </span>}
                <a href="#accueil" className="underline-offset-4 transition-opacity duration-150 ease-ville hover:underline" data-id="element-1344" data-mp="29zgjxyclmol2">
                  {label}
                </a>
              </li>)}
            <li className="flex items-center gap-3" data-id="element-1345" data-mp="3l90lhpgqmmw3">
              <span className="text-white/50" aria-hidden="true" data-id="element-1346" data-mp="3l9sin4pzgsoh">
                |
              </span>
              <a href="#accueil" aria-label="Facebook" className="grid h-7 w-7 place-items-center rounded-full transition-colors duration-150 ease-ville hover:bg-white/20" data-id="element-1347" data-mp="3gck0330xammp">
                <FacebookIcon className="h-4 w-4" aria-hidden="true" data-id="element-1348" data-mp="3q7ty7fo7a9v7" />
              </a>
            </li>
            <li className="flex items-center gap-3" data-id="element-1349" data-mp="81fnrqp54i1k">
              <span className="text-white/50" aria-hidden="true" data-id="element-1350" data-mp="3477xwrgsq3h">
                |
              </span>
              <a href="#accueil" className="underline-offset-4 transition-opacity duration-150 ease-ville hover:underline" data-id="element-1351" data-mp="htd050rvxg1v">
                {footerInfo.links[3]}
              </a>
            </li>
          </ul>
        </div>

        <p className="mt-8 border-t border-white/40 pt-5 text-sm" data-id="element-1352" data-mp="quji7ea6myx8">{footerInfo.copyright}</p>
      </div>
    </footer>;
}